import React from 'react';
import Component from '@vfuk/core-toggle';
const Toggle = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Toggle;
